"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var localStyles = require("./BroadbandCart.scss");
var cartViewPanelStyles = require("../../panels/CartViewPanel/CartViewPanel.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var CartViewPanelProps_1 = require("../../panels/CartViewPanel/CartViewPanelProps");
var CartViewPanel_1 = require("../../panels/CartViewPanel");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var RemoveModalContent_1 = require("../shared/RemoveModalContent");
var Api_1 = require("../../../api/Api");
var ReportingService_1 = require("../../../api/ReportingService");
var StateProvider_1 = require("../../../api/StateProvider");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../cms/Cart.cms");
var BroadbandCart_cms_1 = require("./BroadbandCart.cms");
var Utils = require("../../../utils/UtilityFunctions");
var cartUtils = require("../../../utils/CartUtilFunctions");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var CartItemPromo_1 = require("../../atoms/CartItemPromo");
var components_1 = require("@idp/duc/components");
var VoipCart_1 = require("../VoipCart");
var BusinessTools_1 = require("../BusinessTools");
var BroadbandCart = /** @class */ (function (_super) {
    __extends(BroadbandCart, _super);
    function BroadbandCart(props) {
        var _this = _super.call(this, props) || this;
        _this.classNames = require('classnames/bind');
        _this.cx = _this.classNames.bind(localStyles);
        _this.learnMoreModalLegalObj = {};
        _this.isSpecialBBPricing = false;
        _this.isSMB = false;
        _this.isEmployee = false;
        _this.isVoip = false;
        _this.isBusiness = false;
        _this.businessLobLists = Utils.getLobList();
        _this.state = {
            isLoading: false,
            isRemoveModalOpen: false,
            legalContenFound: false,
            showLearnMoreModal: false,
        };
        _this.initializeEvents();
        _this.toggleRemoveModal = _this.toggleRemoveModal.bind(_this);
        _this.onCartRemove = _this.onCartRemove.bind(_this);
        _this.initializeProps = _this.initializeProps.bind(_this);
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.setPriceContainer = _this.setPriceContainer.bind(_this);
        _this.checkOfferQualifiedDMA = _this.checkOfferQualifiedDMA.bind(_this);
        _this.checkOfferQualifiedPlan = _this.checkOfferQualifiedPlan.bind(_this);
        _this.checkPlanQualified = _this.checkPlanQualified.bind(_this);
        _this.showOfferMessage = _this.showOfferMessage.bind(_this);
        _this.getPromotion = _this.getPromotion.bind(_this);
        return _this;
    }
    BroadbandCart.prototype.componentDidMount = function () {
        this.getLegalContent(this.cmsContent.learnMoreLegal, this.learnMoreModalLegalObj);
        if (cartUtils.getAcpEligibilityPromo()) {
            document.cookie = 'acpPromoCookie=true; domain=.att.com';
        }
    };
    BroadbandCart.prototype.initializeProps = function () {
        var payload = Utils.getCartResp();
        if (payload) {
            var losgs = Object.keys(payload.broadbandCart.losgs);
            var broadbandKey = losgs && losgs.find(function (key) { return key.indexOf('losg_broadband') > -1; });
            this.orderPriceInfoDueMonthly = payload.orderPriceInfo.dueMonthly;
            this.broadbandCartLosgs = Object.values(payload.broadbandCart.losgs);
            this.props.data.dueMonthly = payload.broadbandCart.totalLobDueMonthly;
            this.props.data.dueToday = payload.broadbandCart.totalLobDueToday;
            this.props.data.freeTrial = (typeof payload.broadbandCart.trialPromo !== 'undefined');
            this.props.data.isTaxCalculated = payload.orderPriceInfo.taxCalculated;
            this.props.data.lobTax = payload.broadbandCart.totalLobTax;
            this.props.data.losgData = payload.broadbandCart.customerType ? payload.broadbandCart.losgs[losgs[0]] :
                payload.broadbandCart.losgs[broadbandKey];
            this.props.data.promotions = payload.broadbandCart.promotions;
            this.props.data.trialPromo = payload.broadbandCart.trialPromo;
            this.props.data.totalLob1stBill = payload.broadbandCart.totalLob1stBill;
            this.cartMetaData = payload.metadata.metadata.broadbandMetadata;
            this.props.data.customerType = payload.broadbandCart.customerType;
            this.isSMB = this.props.data.customerType === 'SMB';
            this.isEmployee = this.props.data.customerType === 'employee';
            this.isVoip = payload.voipCart ? true : false;
            this.isBusiness = payload.businessAppCart ? true : false;
        }
    };
    BroadbandCart.prototype.displayEquipmentSection = function (uvModem) {
        var sortedBBItems = this.organizeBBLineItems(uvModem);
        var isEquipment = false;
        if (sortedBBItems.length > 0) {
            for (var _i = 0, sortedBBItems_1 = sortedBBItems; _i < sortedBBItems_1.length; _i++) {
                var lineItem = sortedBBItems_1[_i];
                if ((typeof lineItem.price.baseAmount === 'string' && parseInt(lineItem.price.baseAmount, 10) > 0) ||
                    ((this.isSpecialBBPricing || this.isSMB) && (lineItem.itemType === 'uvHSIAEquipmentAccess' ||
                        lineItem.itemType === 'equipmentAccess'))) {
                    isEquipment = true;
                    break;
                }
            }
        }
        if (isEquipment) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: [localStyles.strongCart, localStyles.paddingtop15].join(' ') }, !(this.isSMB) &&
                    this.cmsContent.titleEquipment),
                this.getLineItem(sortedBBItems, true, true, 'Wifi Gateway router')));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    BroadbandCart.prototype.displayAddOns = function (addOns) {
        if (addOns.length > 0 &&
            (typeof addOns[0].price.baseAmount === 'string' && parseInt(addOns[0].price.baseAmount, 10) > 0)) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: [localStyles.strongCart, localStyles.paddingtop15].join(' ') }, this.cmsContent.addonTitle || 'Add-ons'),
                this.getLineItem(addOns, true, true)));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    BroadbandCart.prototype.displayInstallation = function (installationItem) {
        if (installationItem.length > 0 &&
            (typeof installationItem[0].price.baseAmount === 'string' &&
                parseInt(installationItem[0].price.baseAmount, 10) > 0)) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: [localStyles.strongCart, localStyles.paddingtop15].join(' ') }, this.cmsContent.oneTimeChargeTitle || 'One-time charge:'),
                this.getLineItem(installationItem, true, true)));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    BroadbandCart.prototype.organizeBBLineItems = function (lineItems) {
        var LINE_ITEM_PRIORITY = ['UVHSIAEQUIPMENTACCESS', 'EQUIPMENTACCESS', 'UVINSTALL', 'INSTALLATION',
            'WIFIEXTENDERSERVICE'];
        var lineItemPriorty;
        lineItemPriorty = LINE_ITEM_PRIORITY;
        function shortItems(itemA, itemB) {
            return lineItemPriorty.indexOf(itemA.itemType.toUpperCase()) >
                lineItemPriorty.indexOf(itemB.itemType.toUpperCase()) ? 1 : -1;
        }
        if (lineItems) {
            return lineItems.sort(shortItems);
        }
        else {
            return null;
        }
    };
    BroadbandCart.prototype.acpurl = function (isError) {
        cartUtils.setAcpCustomerPropsInSessionStorage('FIBER');
        var acpURL = "" + location.host === 'idse2.dev.att.com:10081'
            ? location.protocol + "//" + location.host + "/microsites/v1/acp/verification"
            : location.protocol + "//" + location.host + "/acp/verification";
        this.reportingService.fireLinkClickWithOutPageLoad(this.cmsContent.acpVerifcationLink, acpURL);
        this.reportingService.firePageLoadEvent(acpURL);
        window.location.href = isError ? 'tel:${this.cmsContent.acpSystemErrorNumber}' : acpURL;
    };
    BroadbandCart.prototype.renderACPMessage = function () {
        var acpCustomerStatus = cartUtils.getAcpCustomerStatusFromSessionStorage();
        var eligibilityIndicator = (acpCustomerStatus || {}).eligibilityIndicator;
        // show message if there is no sessionStorageItem or if there is sessionStorageItem & eligibilityIndicator is true
        if (cartUtils.acpVerification() && (!acpCustomerStatus || eligibilityIndicator === true)) {
            return (React.createElement("div", { className: localStyles.acpContainer },
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, type: "warning" },
                    React.createElement("span", { className: localStyles.acpText },
                        this.cmsContent.acpVerficationMessage,
                        "\u00A0"),
                    React.createElement(components_1.Link, { kind: "textPlain", className: localStyles.acpText, onClick: this.acpurl.bind(this, false) }, this.cmsContent.acpVerifcationLink))));
        }
        else if (cartUtils.isAcpSystemError() && (!acpCustomerStatus || eligibilityIndicator === true)) {
            return (React.createElement("div", { className: localStyles.acpContainer },
                React.createElement(components_1.Alert, { closeable: true, onWhite: true, type: "error" },
                    React.createElement("span", { className: localStyles.acpText },
                        this.cmsContent.acpSystemErrorMessageFirst,
                        "\u00A0"),
                    React.createElement(components_1.Link, { kind: "textPlain", className: localStyles.acpText, onClick: this.acpurl.bind(this, true) }, this.cmsContent.acpSystemErrorNumber),
                    React.createElement("span", { className: localStyles.acpText },
                        "\u00A0",
                        this.cmsContent.acpSystemErrorMessageSecond))));
        }
        else {
            return React.createElement(React.Fragment, null, " ");
        }
    };
    BroadbandCart.prototype.render = function () {
        var _this = this;
        this.initializeProps();
        var lineItems;
        if (this.props.data.customerType === 'SMB'
            || this.props.data.customerType === 'employee') {
            var lineItemsData_1 = [];
            this.broadbandCartLosgs.forEach(function (losg) {
                lineItemsData_1.push((losg.lineItems));
            });
            lineItems = Object.assign({}, lineItemsData_1[0], lineItemsData_1[1]);
        }
        else {
            lineItems = this.props.data.losgData.lineItems;
        }
        var ipUsageLineItems = Object.keys(lineItems).filter(function (key) { return (lineItems[key].itemType === 'uvIPUsage' ||
            lineItems[key].itemType === 'IPAddressType'); });
        var lineItem;
        var hsiaBasePackage = [];
        var uvIPUsage = [];
        var uvModem = [];
        var install = [];
        var uvInstall = [];
        var uvHomeNetwork = [];
        var uvHomewireProtectionPlan = [];
        var addOns = [];
        var wifiExtenderService = [];
        var cmsData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content;
        if (cmsData.broadbandCart && cmsData.broadbandCart.cartSummary) {
            this.cmsContent = cmsData.broadbandCart.cartSummary;
        }
        else {
            this.cmsContent = new BroadbandCart_cms_1.BroadbandCartCms();
        }
        this.isSpecialBBPricing = cartUtils.isSpecialBBPricing(this.cmsContent.specialHsiaOffers);
        Object.keys(lineItems).forEach(function (key) {
            lineItem = lineItems[key];
            if (_this.props.data.customerType === 'SMB') {
                switch (lineItem.itemType) {
                    case 'basePlan':
                        hsiaBasePackage.push(lineItem);
                        break;
                    case 'installation':
                        install.push(lineItem);
                        break;
                    case 'equipmentAccess':
                        uvModem.push(lineItem);
                        break;
                    case 'IPAddressType':
                        uvIPUsage.push(lineItem);
                        break;
                    case 'businessAppsAndServices':
                        addOns.push(lineItem);
                        break;
                    case 'wifiExtenderService':
                        uvModem.push(lineItem);
                        break;
                }
            }
            else {
                switch (lineItem.itemType) {
                    case 'hsia':
                        hsiaBasePackage.push(lineItem);
                        break;
                    case 'uvIPUsage':
                        if (ipUsageLineItems.length === 2) {
                            if (lineItem.price.msrp && lineItem.price.msrp !== 0) {
                                uvIPUsage.push(lineItem);
                            }
                        }
                        else if (ipUsageLineItems.length === 1) {
                            uvIPUsage.push(lineItem);
                        }
                        break;
                    case 'uvModem':
                        uvModem.push(lineItem);
                        break;
                    case 'uvHSIAEquipmentAccess':
                        uvModem.push(lineItem);
                        break;
                    case 'uvInstall':
                        uvInstall.push(lineItem);
                        break;
                    case 'uvHomeNetwork':
                        uvHomeNetwork.push(lineItem);
                        break;
                    case 'uvHomewireProtectionPlan':
                        uvHomewireProtectionPlan.push(lineItem);
                        break;
                    case 'wifiExtenderService':
                        uvModem.push(lineItem);
                        break;
                }
            }
        });
        return (React.createElement("div", { className: localStyles.broadbandcart },
            this.renderACPMessage(),
            this.showOfferMessage(hsiaBasePackage) &&
                React.createElement("div", { className: localStyles.broadbandInfoContainer },
                    React.createElement("div", { className: localStyles.broadbandInfoHeading }, this.cmsContent.infoLowestPriceHeading),
                    React.createElement("span", { className: localStyles.broadbandInfoLegal }, this.cmsContent.infoLowestPriceLegal)),
            React.createElement(CartViewPanel_1.default, { testId: utils_1.default('Broadband', 'CartViewPanel', 'LineItem'), data: this.buildCartViewPanelData(this.props.data), events: this.cartViewEvents, options: {
                    commonPromotionText: '',
                    isPromoTextApplicable: false,
                    isRemoveAllButtonApplicable: true,
                    isTaxApplied: this.props.data.isTaxCalculated,
                    planType: CartViewPanelProps_1.PlanType.BROADBAND,
                    showAccordions: this.props.options && !!this.props.options.showBundlesTreatment,
                } },
                React.createElement("span", { className: localStyles.strongCart }, this.cmsContent.titlePackage),
                this.getPlanLineItem(hsiaBasePackage, uvIPUsage),
                this.getLineItem(uvHomewireProtectionPlan),
                this.displayEquipmentSection(uvModem),
                (this.props.data.customerType === 'SMB'
                    || this.props.data.customerType === 'employee') && this.displayAddOns(addOns),
                (this.props.data.customerType === 'SMB'
                    || this.props.data.customerType === 'employee') && this.displayInstallation(install),
                (this.props.data.customerType !== 'SMB' && this.props.data.customerType !== 'employee') &&
                    uvInstall.length > 0 && this.getLineItem(uvInstall),
                this.getLineItem(uvHomeNetwork),
                this.isVoip && this.isSMB &&
                    React.createElement(VoipCart_1.default, null),
                (this.businessLobLists.length !== 1) && this.isBusiness && this.isSMB &&
                    React.createElement(BusinessTools_1.default, { data: { isStandaloneBusiness: false }, events: this.cartViewEvents })),
            React.createElement(ui_components_1.Modal, { testId: utils_1.default('Broadband', 'Modal', 'ConfirmRemove'), options: {
                    center: true,
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.isRemoveModalOpen,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                }, events: {
                    onClose: function () {
                        _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                        _this.toggleRemoveModal();
                    },
                } }, React.createElement(RemoveModalContent_1.default, { testId: utils_1.default('Broadband', 'RemoveModalContent', 'ConfirmRemove'), events: {
                    onCancelClick: function () {
                        _this.toggleRemoveModal();
                    },
                    onRemoveClick: function () {
                        _this.toggleRemoveModal(true);
                    },
                }, data: {
                    currentLOB: 'BROADBAND',
                    isBundleinCart: Utils.isBundleinCart().isBundleWithoutAccessory,
                    isSonosinCart: Utils.IsSONOSAccessoryInCart(),
                } }))));
    };
    BroadbandCart.prototype.getLineItem = function (pLineItem, displayPriceIfZero, includedIfPriceZero, overwriteDisplayName) {
        var _this = this;
        return pLineItem.map(function (element, index) {
            var installmentPayment = '';
            if ((element.price.numberOfInstallments > 0) &&
                (element.itemType === 'uvInstall' || element.itemType === 'installation')) {
                installmentPayment = element.price.dividedEvenly ?
                    "$" + element.price.baseAmount + "/mo. for " + element.price.numberOfInstallments + " months" :
                    _this.cmsContent.installmentBillingSelected;
            }
            return (React.createElement("div", { key: "lineItem_" + element.id, id: "lineItem_" + element.id },
                React.createElement("div", null,
                    React.createElement("div", { className: localStyles.lineItemContainer },
                        React.createElement("div", { className: localStyles.lineItemName },
                            React.createElement("div", { id: "itemName_" + element.id, className: "" },
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Broadband', 'Label', 'LineItem'), data: { text: element.displayName } }),
                                React.createElement("div", { className: element.price.dividedEvenly ? localStyles.installmentItemMonth :
                                        localStyles.installmentItemName }, installmentPayment),
                                (element.price.numberOfInstallments === 0) &&
                                    (element.price.installmentEligibility === 'Y') &&
                                    (element.itemType === 'uvInstall' || element.itemType === 'installation') && (React.createElement("div", { className: localStyles.line },
                                    React.createElement(ui_components_1.Label, { data: { text: _this.cmsContent.installementLabel }, options: { className: localStyles.installmentItemName } }),
                                    React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: {
                                                __html: _this.cmsContent.installmentEligibleTip,
                                            } }), testId: utils_1.default('Tooltip', 'Broadband_uvInstallment'), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                                        React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION })))))),
                        React.createElement("div", { className: localStyles.lineItemPrice }, (_this.isSpecialBBPricing || _this.isSMB) &&
                            (element.itemType === 'uvHSIAEquipmentAccess' ||
                                element.itemType === 'equipmentAccess') ?
                            React.createElement("div", null, _this.cmsContent.includedLabel ? _this.cmsContent.includedLabel : '') :
                            element.price &&
                                React.createElement("div", { className: "" }, _this.setPriceContainer(element.price))))),
                _this.getPromotion(element)));
        });
    };
    BroadbandCart.prototype.getPromotion = function (pLineItem) {
        var _this = this;
        if (pLineItem.promotionReferences) {
            var promotionNameArry_1 = new Array();
            var promoName_1 = '';
            var isHsiaBasePackage_1 = false;
            return pLineItem.promotionReferences.map(function (element, index) {
                return _this.props.data.promotions.map(function (promoElem) {
                    var pc = promoElem.promotionCycle;
                    var amount = 0;
                    if (promoElem.promoDiscountAmount) {
                        amount = parseFloat(promoElem.promoDiscountAmount);
                    }
                    else {
                        amount = promoElem.amount;
                    }
                    if (element === promoElem.id) {
                        if (pLineItem && pLineItem.itemType && (pLineItem.itemType === 'hsia' ||
                            pLineItem.itemType === 'basePlan')
                            && promoElem && promoElem.promotionName) {
                            isHsiaBasePackage_1 = true;
                            if (amount > 0) {
                                promotionNameArry_1.push(promoElem.promotionName);
                            }
                            if (pLineItem.promotionReferences.length === (index + 1)) {
                                promoName_1 = promotionNameArry_1.join(' + ');
                                isHsiaBasePackage_1 = false;
                            }
                        }
                        else {
                            promoName_1 = amount > 0 ? promoElem.promotionName : '';
                        }
                        return (React.createElement(React.Fragment, null,
                            !isHsiaBasePackage_1 && promoName_1 &&
                                !(pLineItem.itemType === 'basePlan' && _this.isSMB && _this.isVoip) &&
                                React.createElement("div", { key: "promo_" + promoElem.id, id: "promo_" + promoElem.id },
                                    React.createElement(CartItemPromo_1.default, { data: {
                                            isPriceNegative: true, promoPrice: amount,
                                            promoText: promoName_1, promotionCycle: pc,
                                            showPrice: (pLineItem.itemType !== 'hsia' && pLineItem.itemType !== 'basePlan'),
                                        }, options: { testId: utils_1.default('Broadband', 'LineItem') } })),
                            " ",
                            isHsiaBasePackage_1 &&
                                React.createElement(React.Fragment, null, " ")));
                    }
                    else {
                        return (React.createElement(React.Fragment, null));
                    }
                });
            });
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    BroadbandCart.prototype.getPlanLineItem = function (pLineItem, pLineItem2) {
        var _this = this;
        return pLineItem.map(function (element, index) {
            var pkgPrice = 0;
            if (element.price) {
                if (element.itemType === 'hsia' || element.itemType === 'basePlan') {
                    pkgPrice = element.price.amount ? element.price.amount : 0;
                }
                else {
                    pkgPrice = element.price.baseAmount ? element.price.baseAmount : 0;
                }
            }
            return (React.createElement("div", { key: "lineItem_" + element.id, id: "lineItem_" + element.id },
                React.createElement("div", null,
                    React.createElement("div", { className: localStyles.lineItemPlanContainer },
                        React.createElement("div", { className: localStyles.lineItemName },
                            React.createElement("div", { id: "itemName_" + element.id, className: "" },
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Broadband', 'Label', 'LineItem'), data: { text: element.displayName } }))),
                        React.createElement("div", { className: localStyles.lineItemPrice },
                            element.price && Number(pkgPrice) !== 0 &&
                                React.createElement("div", { className: "" },
                                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Broadband', 'PriceContainer', 'LineItem'), data: {
                                            billingNote: (element.price.priceType === 'RC') ? '/mo.' : '',
                                            price: pkgPrice,
                                        }, options: {
                                            className: localStyles.lineItem,
                                            decimalPoints: 2,
                                            type: PriceContainerProps_1.PricingType.XSMALL,
                                        } })),
                            Number(pkgPrice) === 0 &&
                                React.createElement(ui_components_1.Label, { testId: utils_1.default('BROADBAND', 'Price', 'Free'), data: { text: 'FREE' }, options: { className: localStyles.freeText } })))),
                _this.getIpUsageLineItem(pLineItem2, element.displayName, false),
                _this.getPromotion(element)));
        });
    };
    BroadbandCart.prototype.togglelearnMoreModal = function () {
        var _this = this;
        this.setState({ showLearnMoreModal: !this.state.showLearnMoreModal }, function () {
            if (_this.state.showLearnMoreModal) {
                _this.reportingService.fireLinkClickWithOutPageLoad('Learn more', ReportingService_1.PageUrls.BB_LEARN_MORE_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.BB_LEARN_MORE_MODAL);
            }
            else {
                _this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.BB_LEARN_MORE_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
        });
    };
    BroadbandCart.prototype.learnMore = function (element) {
        var content = {
            common: {
                learnMoreContentFirst: this.learnMoreModalLegalObj.longtext,
                learnMoreLink: this.learnMoreModalLegalObj.shortdesclinktext,
                learnMoreTitle: this.learnMoreModalLegalObj.modaltitle,
            },
        };
        if (element.displayName.toLowerCase().indexOf('unlimited') === -1) {
            return (React.createElement(React.Fragment, null,
                "\u00A0",
                React.createElement(components_1.Link, { kind: "textPlain", className: localStyles.legalLink, 
                    // tslint:disable-next-line: jsx-no-bind
                    onClick: this.togglelearnMoreModal.bind(this), testId: utils_1.default('Broadband', 'Link', "Learn_More_Cart") }, content.common.learnMoreLink),
                React.createElement(ui_components_1.Modal, { testId: utils_1.default('Broadband', 'Modal', "Learn_More_Modal"), options: {
                        center: true,
                        show: this.state.showLearnMoreModal,
                        showClose: true,
                        size: ModalProps_1.ModalSizes.MEDIUM,
                        tabIndex: 0,
                    }, events: { onClose: this.togglelearnMoreModal.bind(this) } },
                    React.createElement("div", { className: cartViewPanelStyles.legalContainer },
                        React.createElement(ui_components_1.Label, { data: { text: content.common.learnMoreTitle }, options: { className: cartViewPanelStyles.legalHeading,
                                size: LabelProps_1.LabelSizes.SMALLHEADING24 } }),
                        React.createElement("p", { dangerouslySetInnerHTML: {
                                __html: content.common.learnMoreContentFirst,
                            } })))));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    BroadbandCart.prototype.getIpUsageLineItem = function (pLineItem, planDisplayName, displayPriceIfZero) {
        var _this = this;
        displayPriceIfZero = (typeof displayPriceIfZero === 'undefined') ? true : displayPriceIfZero;
        var speed = planDisplayName.match(/\d+(kbps)?/)[0];
        if (speed.indexOf('kbps') === -1) {
            if (speed === '1000') {
                speed = speed + "Mbps connection ";
            }
            else {
                speed = "Up to " + speed + "Mbps ";
            }
        }
        var lineItemClassName = !(this.isSMB || this.isEmployee) ? localStyles.lineItemSmall : localStyles.smbInstall;
        return pLineItem.map(function (element, index) {
            return (element.uiDisplayLineItem &&
                (React.createElement("div", { key: "lineItem_" + element.id, id: "lineItemSpeed_" + element.id },
                    React.createElement("div", null,
                        React.createElement("div", { className: localStyles.lineItemPlanContainer },
                            React.createElement("div", { className: localStyles.lineItemName },
                                React.createElement("div", { id: "itemName_" + element.id, className: lineItemClassName },
                                    React.createElement(ui_components_1.RichText, { testId: utils_1.default('Broadband', 'Label', 'LineItem'), data: { text: speed + element.displayName } }),
                                    _this.learnMore(element))),
                            React.createElement("div", { className: localStyles.lineItemPrice },
                                element.price &&
                                    (element.price.baseAmount > 0 || displayPriceIfZero) &&
                                    React.createElement("div", { className: localStyles.lineItemSmall }, _this.setPriceContainer(element.price)),
                                (_this.isSMB || _this.isEmployee) && element.price &&
                                    Number(element.price.baseAmount) === 0 &&
                                    React.createElement("div", { className: localStyles.lineItemSmall }, _this.cmsContent.includedLabel ? _this.cmsContent.includedLabel : '')))),
                    _this.getPromotion(element))));
        });
    };
    BroadbandCart.prototype.showOfferMessage = function (pLineItem) {
        var payload = Utils.getCartResp();
        var isDMAFlagEnabled = payload && payload.enableDmaServiceAddress;
        var showMessage = isDMAFlagEnabled && cartUtils.checkNewBBCart()
            && this.checkOfferQualifiedPlan(pLineItem)
            && this.checkOfferQualifiedDMA(payload);
        return showMessage;
    };
    BroadbandCart.prototype.checkOfferQualifiedPlan = function (pLineItem) {
        var offerSku = this.cmsContent.offerSku;
        var isPlanQualified = this.checkPlanQualified(pLineItem, offerSku);
        return isPlanQualified;
    };
    BroadbandCart.prototype.checkOfferQualifiedDMA = function (payload) {
        var dmaList = this.cmsContent.dmaList;
        var qualifiedDMA = false;
        if (payload && payload.broadbandCart && payload.broadbandCart.dma) {
            var cartDma = payload.broadbandCart.dma;
            if (dmaList && dmaList.split(',') && dmaList.split(',').length > 0) {
                qualifiedDMA = dmaList.split(',').includes(cartDma);
            }
        }
        return qualifiedDMA;
    };
    BroadbandCart.prototype.checkPlanQualified = function (pLineItem, offerSku) {
        var isPlanQualified = false;
        pLineItem.forEach(function (element, index) {
            if (element.productSKU === offerSku) {
                isPlanQualified = true;
            }
        });
        return isPlanQualified;
    };
    BroadbandCart.prototype.setPriceContainer = function (priceData) {
        return (React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('Broadband', 'PriceContainer', 'LineItem'), data: {
                billingNote: (priceData.priceType === 'RC') ? '/mo' : '',
                price: (priceData.baseAmount) ? priceData.baseAmount : 0,
            }, options: {
                className: localStyles.lineItem,
                decimalPoints: 2,
                type: PriceContainerProps_1.PricingType.XSMALL,
            } }));
    };
    BroadbandCart.prototype.buildCartViewPanelData = function (data) {
        var _a, _b, _c, _d;
        var dueTodayLegalContents = cartUtils.getLegalIDPDetails(this.cmsContent.dueTodayLegalIDP);
        var dueFirstMonthLegalContents = this.isSpecialBBPricing ?
            cartUtils.getLegalIDPDetails(this.cmsContent.bbPricingDueOnFirstBillLegalIDP) :
            cartUtils.getLegalIDPDetails(this.cmsContent.dueOnFirstBillLegalIDP);
        if (this.isVoip || this.isBusiness) {
            data.dueMonthly = this.orderPriceInfoDueMonthly;
        }
        return {
            due1stBillHeading: this.cmsContent.dueOneTimeCharges,
            due1stBillModalLegalContents: dueFirstMonthLegalContents,
            due1stBillModalLegalUrl: (_b = (_a = this.cmsContent) === null || _a === void 0 ? void 0 : _a.dueOnFirstBillLegalIDP) === null || _b === void 0 ? void 0 : _b.legalModalPath[0],
            due1stBillPrice: data.totalLob1stBill || 0,
            dueMonthlyLabel: this.cmsContent.dueMonthlyHeading,
            dueMonthlyPrice: data.dueMonthly || 0,
            dueTodayModalLegalContents: dueTodayLegalContents,
            dueTodayModalLegalUrl: (_d = (_c = this.cmsContent) === null || _c === void 0 ? void 0 : _c.dueTodayLegalIDP) === null || _d === void 0 ? void 0 : _d.legalModalPath[0],
            dueTodayPrice: data.dueToday,
            lineOfBusinessName: this.cmsContent.lineOfBusinessName,
            removeItemsLinkLabel: this.cmsContent.removeItemsLinkLabel,
        };
    };
    BroadbandCart.prototype.loadCart = function (bool) {
        this.setState({ isLoading: bool });
    };
    BroadbandCart.prototype.initializeEvents = function () {
        var _this = this;
        this.cartViewEvents = {
            doLoading: this.loadCart.bind(this),
            onEdit: function () {
                _this.props.events.onEdit('BROADBAND', _this.cartMetaData.editUrl);
            },
            onRemove: this.toggleRemoveModal.bind(this),
        };
    };
    BroadbandCart.prototype.toggleRemoveModal = function (onlyPageLoadOnRemove) {
        var _this = this;
        this.setState({ isRemoveModalOpen: !this.state.isRemoveModalOpen }, function () {
            if (onlyPageLoadOnRemove) {
                _this.onCartRemove();
            }
            else if (_this.state.isRemoveModalOpen) {
                _this.reportingService.fireLinkClickWithOutPageLoad(_this.cmsContent.removeItemsLinkLabel, ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
            }
            else {
                _this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
        });
    };
    BroadbandCart.prototype.onCartRemove = function () {
        var _this = this;
        this.props.events.doLoading(true);
        var editLink = Utils.getEditLinkUrl(this.cartMetaData.editUrl);
        this.stateManager.set('editLinkUrl', { url: editLink });
        var isBundleCart = Utils.isBundleinCart().isBundleWithoutAccessory;
        this.reportingService.reportSystemEventForSelectedAction(false, '-2', 'Remove', isBundleCart ? ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT :
            ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
        this.api.emptyAnyLOBCart('BROADBAND').then(function (data) {
            if (data.content.status === 'success') {
                _this.reportingService.reportSystemEventForSelectedAction(false, '0', 'Remove', isBundleCart ? ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT :
                    ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
                Utils.onCartRemoveLob(true);
                cartUtils.checkCartRedirectionAfterRemove(data);
            }
            else {
                _this.reportingService.reportSystemEventForSelectedAction(true, undefined, 'Remove', isBundleCart ? ReportingService_1.EventTypesCodes.REMOVE_CART_SUBMIT_EVENT :
                    ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.CART_PAGE, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, "Error in remvoing cart: " + JSON.stringify(data));
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
            _this.props.events.doLoading(false);
        }).catch(function (err) {
            _this.props.events.doLoading(false);
            _this.toggleRemoveModal();
        });
    };
    BroadbandCart.prototype.getLegalContent = function (legalAEMUrl, legalContent) {
        var _this = this;
        if (legalAEMUrl) {
            cartUtils.getLegalIDPData(legalAEMUrl, legalContent, legalContent.longtext, legalContent.shorttext).then(function (response) {
                if (response.shortdesclinktext) {
                    legalContent.shortdesclinktext = response.shortdesclinktext;
                    if (response.longtext) {
                        legalContent.longtext = response.longtext;
                        legalContent.showLegal = true;
                    }
                }
                if (response.shorttext) {
                    legalContent.shorttext = response.shorttext;
                }
                if (response.modaltitle) {
                    legalContent.modaltitle = response.modaltitle;
                }
                _this.setState({ legalContenFound: true });
            }).catch(function (err) {
                legalContent.showLegal = false;
                _this.setState({ legalContenFound: false });
            });
        }
    };
    return BroadbandCart;
}(React.Component));
exports.default = BroadbandCart;
//# sourceMappingURL=BroadbandCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/BroadbandCart/BroadbandCart.js
// module id = 2316
// module chunks = 8